import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    width: 290,
    minWidth: 290,
    borderRadius: 12,
    overflow: 'hidden',
    border: `1px solid ${theme.palette.secondary.superLight}`,
    backgroundColor: theme.palette.background.paper,
    textDecoration: 'none',
    color: 'inherit',
    transition: 'box-shadow 0.15s, transform 0.15s',
    cursor: 'pointer',
    '&:hover': {
      boxShadow: theme.shadows[4],
      transform: 'translateY(-2px)',
    },
  },
  thumbnail: {
    width: '100%',
    height: 120,
    objectFit: 'cover',
    display: 'block',
  },
  thumbnailPlaceholder: {
    width: '100%',
    height: 120,
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.primary.contrastText,
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1.5),
    flex: 1,
    gap: theme.spacing(0.75),
  },
  title: {
    fontSize: 15,
    fontWeight: 600,
    color: theme.palette.text.primary,
    lineHeight: 1.4,
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  },
  progressRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  progressBar: {
    flex: 1,
    height: 4,
    borderRadius: 2,
  },
  progressBarColor: {
    backgroundColor: theme.palette.common.black,
  },
  progressLabel: {
    fontSize: 11,
    fontWeight: 600,
    color: theme.palette.text.secondary,
    minWidth: 28,
    textAlign: 'right',
  },
  metaRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    fontSize: 11,
    color: theme.palette.text.secondary,
  },
  metaIcon: {
    fontSize: 13,
  },
  lastAccess: {
    fontSize: 11,
    color: theme.palette.text.secondary,
  },
  certificateButton: {
    marginTop: theme.spacing(0.5),
    fontSize: 11,
    fontWeight: 600,
  },
}))

export default useStyles
